import React from 'react';

const BadgeList = ({ list }) => {
  return (
    <div className='detail-badge-list'>
      {
        list.map((item, index) => (
          <span key={index} className='detail-badge-list__item'>
            {item}
          </span>
        ))
      }
    </div>
  )
}

export default BadgeList;
